(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/render-context/assets/javascripts/render-provider.js') >= 0) return;  svs.modules.push('/components/tipsen/render-context/assets/javascripts/render-provider.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const pageTypes = svs.component.tipsen.renderContext.constants.pageTypes;
const RenderProvider = _ref => {
  let children = _ref.children,
    pageType = _ref.pageType;
  const context = useMemo(() => ({
    pageType,
    isResultOrMybets: pageType === pageTypes.RESULT || pageType === pageTypes.MY_BETS,
    isResult: pageType === pageTypes.RESULT,
    isMyBet: pageType === pageTypes.MY_BETS
  }), [pageType]);
  return React.createElement(RenderContext.Provider, {
    value: context
  }, children);
};
setGlobal('svs.component.tipsen.renderContext.RenderProvider', RenderProvider);

 })(window);